 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"auth":"auth","cc-publicprint":"cc-publicprint","company-address~company-allowance~company-cloudcanteen~company-edit~company-invoices~company-teams~c~4e9d5011":"company-address~company-allowance~company-cloudcanteen~company-edit~company-invoices~company-teams~c~4e9d5011","company-address~user-address-list":"company-address~user-address-list","company-address":"company-address","user-address-list":"user-address-list","company-allowance~restaurant-edit":"company-allowance~restaurant-edit","company-allowance":"company-allowance","company-cloudcanteen":"company-cloudcanteen","company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~or~f85664fe":"company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~or~f85664fe","company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~pr~0ae83d82":"company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~pr~0ae83d82","restaurant-edit":"restaurant-edit","company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit":"company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit","company-edit":"company-edit","company-invoices":"company-invoices","delivery-edit":"delivery-edit","delivery-list":"delivery-list","promo-edit":"promo-edit","tag-edit":"tag-edit","tag-group-edit":"tag-group-edit","user-edit":"user-edit","custom-export-create":"custom-export-create","custom-export-edit":"custom-export-edit","order-edit":"order-edit","company-teams":"company-teams","user-address-edit":"user-address-edit","company-balances":"company-balances","company-employees":"company-employees","company-list":"company-list","confirm":"confirm","custom-export-list":"custom-export-list","home":"home","invoices-create~invoices-edit":"invoices-create~invoices-edit","invoices-create":"invoices-create","invoices-edit":"invoices-edit","invoices-dashboard":"invoices-dashboard","order-preview-email":"order-preview-email","promo-list":"promo-list","restaurant-list":"restaurant-list","tablets":"tablets","tag-groups-list":"tag-groups-list","tag-list":"tag-list","translations-list":"translations-list","user-list":"user-list"}[chunkId]||chunkId) + "." + {"auth":"0223d5fc","cc-publicprint":"0f77065f","company-address~company-allowance~company-cloudcanteen~company-edit~company-invoices~company-teams~c~4e9d5011":"0d7cc802","company-address~user-address-list":"0be15bf1","company-address":"10ec985f","user-address-list":"e3a1ec1c","company-allowance~restaurant-edit":"6888a228","company-allowance":"d1575efe","company-cloudcanteen":"62084f12","company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~or~f85664fe":"72eba045","company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~pr~0ae83d82":"2c067a83","restaurant-edit":"4fea2bb3","company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit":"7092a1f9","company-edit":"c25671a0","company-invoices":"66cb95f1","delivery-edit":"70af62c6","delivery-list":"f93d0c61","promo-edit":"aca4ee77","tag-edit":"7abb8fa4","tag-group-edit":"99b45a60","user-edit":"e0c36a7f","custom-export-create":"0af3137c","custom-export-edit":"d4c56740","order-edit":"91d330f8","company-teams":"fd6d0d90","user-address-edit":"e956583e","company-balances":"d2b04807","company-employees":"1da9cefc","company-list":"755e8bf7","confirm":"26980ff0","custom-export-list":"5294b5ff","home":"e5844091","invoices-create~invoices-edit":"7aea4067","invoices-create":"1f56fa0c","invoices-edit":"36ac6948","invoices-dashboard":"2dc6cce5","order-preview-email":"d01e5747","promo-list":"167e354e","restaurant-list":"8bdbbfd0","tablets":"8548514d","tag-groups-list":"01c08038","tag-list":"46873c9b","translations-list":"d6998ea7","user-list":"b02d40cc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"auth":1,"company-address~company-allowance~company-cloudcanteen~company-edit~company-invoices~company-teams~c~4e9d5011":1,"user-address-list":1,"company-allowance~restaurant-edit":1,"company-allowance":1,"company-cloudcanteen":1,"company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~or~f85664fe":1,"company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~pr~0ae83d82":1,"restaurant-edit":1,"company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit":1,"delivery-edit":1,"promo-edit":1,"tag-edit":1,"user-edit":1,"order-edit":1,"company-balances":1,"company-employees":1,"confirm":1,"invoices-create~invoices-edit":1,"promo-list":1,"restaurant-list":1,"tablets":1,"tag-list":1,"translations-list":1,"user-list":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"auth":"auth","cc-publicprint":"cc-publicprint","company-address~company-allowance~company-cloudcanteen~company-edit~company-invoices~company-teams~c~4e9d5011":"company-address~company-allowance~company-cloudcanteen~company-edit~company-invoices~company-teams~c~4e9d5011","company-address~user-address-list":"company-address~user-address-list","company-address":"company-address","user-address-list":"user-address-list","company-allowance~restaurant-edit":"company-allowance~restaurant-edit","company-allowance":"company-allowance","company-cloudcanteen":"company-cloudcanteen","company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~or~f85664fe":"company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~or~f85664fe","company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~pr~0ae83d82":"company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~pr~0ae83d82","restaurant-edit":"restaurant-edit","company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit":"company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit","company-edit":"company-edit","company-invoices":"company-invoices","delivery-edit":"delivery-edit","delivery-list":"delivery-list","promo-edit":"promo-edit","tag-edit":"tag-edit","tag-group-edit":"tag-group-edit","user-edit":"user-edit","custom-export-create":"custom-export-create","custom-export-edit":"custom-export-edit","order-edit":"order-edit","company-teams":"company-teams","user-address-edit":"user-address-edit","company-balances":"company-balances","company-employees":"company-employees","company-list":"company-list","confirm":"confirm","custom-export-list":"custom-export-list","home":"home","invoices-create~invoices-edit":"invoices-create~invoices-edit","invoices-create":"invoices-create","invoices-edit":"invoices-edit","invoices-dashboard":"invoices-dashboard","order-preview-email":"order-preview-email","promo-list":"promo-list","restaurant-list":"restaurant-list","tablets":"tablets","tag-groups-list":"tag-groups-list","tag-list":"tag-list","translations-list":"translations-list","user-list":"user-list"}[chunkId]||chunkId) + "." + {"auth":"fb636346","cc-publicprint":"31d6cfe0","company-address~company-allowance~company-cloudcanteen~company-edit~company-invoices~company-teams~c~4e9d5011":"7fbdab98","company-address~user-address-list":"31d6cfe0","company-address":"31d6cfe0","user-address-list":"b67733e0","company-allowance~restaurant-edit":"5dce7586","company-allowance":"a707ff83","company-cloudcanteen":"74ee0c34","company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~or~f85664fe":"a707ff83","company-edit~company-invoices~custom-export-create~custom-export-edit~delivery-edit~delivery-list~pr~0ae83d82":"fd72e4e2","restaurant-edit":"c22614ad","company-edit~company-invoices~delivery-edit~delivery-list~promo-edit~tag-edit~tag-group-edit~user-edit":"b13ba4fd","company-edit":"31d6cfe0","company-invoices":"31d6cfe0","delivery-edit":"6b43a716","delivery-list":"31d6cfe0","promo-edit":"ed224c5e","tag-edit":"b551b416","tag-group-edit":"31d6cfe0","user-edit":"0f10bbee","custom-export-create":"31d6cfe0","custom-export-edit":"31d6cfe0","order-edit":"86251e18","company-teams":"31d6cfe0","user-address-edit":"31d6cfe0","company-balances":"7fbdab98","company-employees":"ff80b40c","company-list":"31d6cfe0","confirm":"b85d36da","custom-export-list":"31d6cfe0","home":"31d6cfe0","invoices-create~invoices-edit":"663f8951","invoices-create":"31d6cfe0","invoices-edit":"31d6cfe0","invoices-dashboard":"31d6cfe0","order-preview-email":"31d6cfe0","promo-list":"74db83ac","restaurant-list":"559607c5","tablets":"16bd2147","tag-groups-list":"31d6cfe0","tag-list":"1d483a6f","translations-list":"5e90908b","user-list":"559607c5"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
